import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { ErrorOverlay } from "../../common/ErrorOverlay";
import { LoadingOverlay } from "../../common/LoadingOverlay";
import { OpenInCodeSandboxButton } from "../../common/OpenInCodeSandboxButton";
import { SandpackStack } from "../../common/Stack";
import { useSandpack } from "../../hooks/useSandpack";
import { generateRandomId } from "../../utils/stringUtils";
import { Navigator } from "../Navigator";
import { RefreshButton } from "./RefreshButton";
export { RefreshButton };
export var SandpackPreview = function SandpackPreview(_ref) {
  var customStyle = _ref.customStyle,
      _ref$showNavigator = _ref.showNavigator,
      showNavigator = _ref$showNavigator === void 0 ? false : _ref$showNavigator,
      _ref$showRefreshButto = _ref.showRefreshButton,
      showRefreshButton = _ref$showRefreshButto === void 0 ? true : _ref$showRefreshButto,
      _ref$showOpenInCodeSa = _ref.showOpenInCodeSandbox,
      showOpenInCodeSandbox = _ref$showOpenInCodeSa === void 0 ? true : _ref$showOpenInCodeSa,
      _ref$showSandpackErro = _ref.showSandpackErrorOverlay,
      showSandpackErrorOverlay = _ref$showSandpackErro === void 0 ? true : _ref$showSandpackErro,
      _ref$viewportSize = _ref.viewportSize,
      viewportSize = _ref$viewportSize === void 0 ? "auto" : _ref$viewportSize,
      _ref$viewportOrientat = _ref.viewportOrientation,
      viewportOrientation = _ref$viewportOrientat === void 0 ? "portrait" : _ref$viewportOrientat;

  var _useSandpack = useSandpack(),
      sandpack = _useSandpack.sandpack,
      listen = _useSandpack.listen;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      iframeComputedHeight = _React$useState2[0],
      setComputedAutoHeight = _React$useState2[1];

  var status = sandpack.status,
      registerBundler = sandpack.registerBundler,
      unregisterBundler = sandpack.unregisterBundler,
      errorScreenRegisteredRef = sandpack.errorScreenRegisteredRef,
      openInCSBRegisteredRef = sandpack.openInCSBRegisteredRef,
      loadingScreenRegisteredRef = sandpack.loadingScreenRegisteredRef;
  var c = useClasser("sp");
  var clientId = React.useRef(generateRandomId());
  var iframeRef = React.useRef(null); // SandpackPreview immediately registers the custom screens/components so the bundler does not render any of them

  openInCSBRegisteredRef.current = true;
  errorScreenRegisteredRef.current = true;
  loadingScreenRegisteredRef.current = true;
  React.useEffect(function () {
    var iframeElement = iframeRef.current;
    registerBundler(iframeElement, clientId.current);
    var unsub = listen(function (message) {
      if (message.type === "resize") {
        setComputedAutoHeight(message.height);
      }
    }, clientId.current);
    return function () {
      unsub();
      unregisterBundler(clientId.current);
    };
  }, []);

  var handleNewURL = function handleNewURL(newUrl) {
    if (!iframeRef.current) {
      return;
    }

    iframeRef.current.src = newUrl;
  };

  var viewportStyle = computeViewportSize(viewportSize, viewportOrientation);
  return React.createElement(SandpackStack, {
    customStyle: _objectSpread(_objectSpread(_objectSpread({}, customStyle), viewportStyle), {}, {
      display: status !== "idle" ? "flex" : "none"
    })
  }, showNavigator ? React.createElement(Navigator, {
    clientId: clientId.current,
    onURLChange: handleNewURL
  }) : null, React.createElement("div", {
    className: c("preview-container")
  }, React.createElement("iframe", {
    ref: iframeRef,
    className: c("preview-iframe"),
    style: {
      // set height based on the content only in auto mode
      // and when the computed height was returned by the bundler
      height: viewportSize === "auto" && iframeComputedHeight ? iframeComputedHeight : undefined
    },
    title: "Sandpack Preview"
  }), showSandpackErrorOverlay ? React.createElement(ErrorOverlay, null) : null, React.createElement("div", {
    className: c("preview-actions")
  }, !showNavigator && showRefreshButton && status === "running" ? React.createElement(RefreshButton, {
    clientId: clientId.current
  }) : null, showOpenInCodeSandbox ? React.createElement(OpenInCodeSandboxButton, null) : null), React.createElement(LoadingOverlay, {
    clientId: clientId.current
  })));
};
var VIEWPORT_SIZE_PRESET_MAP = {
  "iPhone X": {
    x: 375,
    y: 812
  },
  iPad: {
    x: 768,
    y: 1024
  },
  "Pixel 2": {
    x: 411,
    y: 731
  },
  "Moto G4": {
    x: 360,
    y: 640
  },
  "Surface Duo": {
    x: 540,
    y: 720
  }
};

var computeViewportSize = function computeViewportSize(viewport, orientation) {
  if (viewport === "auto") {
    return {};
  }

  if (typeof viewport === "string") {
    var _VIEWPORT_SIZE_PRESET = VIEWPORT_SIZE_PRESET_MAP[viewport],
        x = _VIEWPORT_SIZE_PRESET.x,
        y = _VIEWPORT_SIZE_PRESET.y;
    return orientation === "portrait" ? {
      width: x,
      height: y
    } : {
      width: y,
      height: x
    };
  }

  return viewport;
};